module.exports = __webpack_public_path__ + "media/images/flags/tz-ab361d2e9467a40761122f232031b7ab.svg";